<template>
    <div class="author-chapter-base" id="author">
        <div class="container">
            <div class="content text-center">
                <feature-icon color="teal" icon="build"></feature-icon>
                <h2>成为作者</h2>
                <p><span>广场提供了强大的编辑器用于游戏制作，即使没有编程经验，也可以制作出属于自己的魔塔游戏</span></p>
                <div class="playground-demo-base">
                    <div class="playground-list-select-base">
                        <div class="visible-xs pull-right playground-list-select-caret">
                            <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="playground-demo">
                        <div class="playground-iframe">
                            <a href="/games/9922/editor.html" target="_blank">
                                <img height="height: 400px;" src="/assets/editor.png">
                            </a>
                        </div>
                    </div>
                </div>
                <a href="https://github.com/ckcz123/mota-js" target="_blank">
                    <p class="link">加入造塔群 <a-icon type="right"></a-icon></p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import FeatureIcon from './FeatureIcon.vue'

export default {
    components: {
        FeatureIcon,
    },
}
</script>

<style lang="less">
.author-chapter-base {
    margin-top: 30px;
    @media (min-width: 768px) {
        margin-top: 30px;
        .playground-iframe {
            img {
                height: 400px;
            }
        }
    }
    .content {
        margin-top: 50px;
    }
    .playground-demo-base {
        margin-top: 30px;
        @media (max-width: 767px) {
            margin-top: 15px;
            .playground-iframe {
                img {
                    width: 100%;
                }
            }
        }
    }
    .playground-demo {
        margin-top: 20px;
        border-radius: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        .playground-iframe {
            background: white;
            position: relative;
            -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
                    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
            border-radius: 5px;
            margin: auto;
        }
    }
}
</style>